import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormPageComponent} from '@components/pages/page-components/form-page/form-page.component';
import {FramePageComponent} from '@components/pages/page-components/frame-page/frame-page.component';
import {
  InteractiveDataAnalysisComponent
} from '@components/pages/page-components/interactive-data-analysis/interactive-data-analysis.component';
import {LookerPageComponent} from '@components/pages/page-components/looker-page/looker-page.component';
import {TableauPageComponent} from '@components/pages/page-components/tableau-page/tableau-page.component';
import {WebglPageComponent} from '@components/pages/page-components/webgl-page/webgl-page.component';
import {SharedModule} from '@shared/shared.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {NgSelectModule} from '@ng-select/ng-select';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {
  TableauPageActionsComponent
} from '@components/pages/page-components/tableau-page/tableau-page-actions/tableau-page-actions.component';
import {
  WebglPageActionsComponent
} from '@components/pages/page-components/webgl-page/webgl-page-actions/webgl-page-actions.component';
import {
  InteractiveDataAnalysisActionsComponent
} from '@components/pages/page-components/interactive-data-analysis/interactive-data-analysis-actions/interactive-data-analysis-actions.component';
import {
  EditTableauPageComponent
} from '@components/pages/page-components/tableau-page/modal/edit-tableau-page/edit-tableau-page.component';
import {StatusEventPageModule} from '@components/pages/page-components/status-event-page/status-event-page.module';
import {
  EditInteractiveDataAnalysisSignalsComponent
} from '@components/pages/page-components/interactive-data-analysis/modal/edit-interactive-data-analysis-signals/edit-interactive-data-analysis-signals.component';
import {
  EditSignalComponent
} from '@components/pages/page-components/interactive-data-analysis/modal/edit-interactive-data-analysis-signals/edit-signal/edit-signal.component';
import {ChartsModule} from '@components/pages/charts/charts.module';
import {
  EmptyStateFallbackComponent
} from '@components/pages/page-components/empty-state-fallback/empty-state-fallback.component';
import {
  FormPageActionsComponent
} from '@components/pages/page-components/form-page/form-page-actions/form-page-actions.component';
import {
  EditFormPageComponent
} from '@components/pages/page-components/form-page/modal/edit-form-page/edit-form-page.component';
import {
  FormPageInputFieldComponent
} from '@components/pages/page-components/form-page/modal/edit-form-page/form-page-input-field/form-page-input-field.component';
import {
  FormPageFieldComponent
} from '@components/pages/page-components/form-page/form-page-field/form-page-field.component';
import {DragulaModule} from 'ng2-dragula';
import {
  LastSubmittedRowModalComponent
} from '@components/pages/page-components/form-page/modal/last-submitted-row-modal/last-submitted-row-modal.component';
import {
  BucketBrowserPageComponent
} from '@components/pages/page-components/bucket-browser-page/bucket-browser-page.component';
import {
  BucketBrowserPageActionsComponent
} from '@components/pages/page-components/bucket-browser-page/bucket-browser-page-actions/bucket-browser-page-actions.component';
import {TableauViz} from '@tableau/embedding-api';

@NgModule({
  declarations: [
    FormPageComponent,
    FramePageComponent,
    InteractiveDataAnalysisComponent,
    LookerPageComponent,
    TableauPageComponent,
    TableauPageActionsComponent,
    WebglPageComponent,
    WebglPageActionsComponent,
    InteractiveDataAnalysisActionsComponent,
    EditTableauPageComponent,
    EditInteractiveDataAnalysisSignalsComponent,
    EditSignalComponent,
    EmptyStateFallbackComponent,
    FormPageActionsComponent,
    EditFormPageComponent,
    FormPageInputFieldComponent,
    FormPageFieldComponent,
    LastSubmittedRowModalComponent,
    BucketBrowserPageComponent,
    BucketBrowserPageActionsComponent
  ],
  exports: [
    FormPageComponent,
    FramePageComponent,
    InteractiveDataAnalysisComponent,
    LookerPageComponent,
    TableauPageComponent,
    WebglPageComponent,
    TableauPageActionsComponent,
    WebglPageActionsComponent,
    InteractiveDataAnalysisActionsComponent,
    EmptyStateFallbackComponent,
    FormPageActionsComponent,
    BucketBrowserPageComponent,
    BucketBrowserPageActionsComponent

  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgSelectModule,
    NgbModule,
    StatusEventPageModule,
    ChartsModule,
    DragulaModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class PageComponentsModule {
}
